<template>
  <div class="project-form">
    <div class="window-container">
      <div class="page-container">
        <v-layout justify-space-between wrap>
          <v-flex sm9>
            <v-layout justify-space-between wrap>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="N° Patient" v-model="patient.patient_id"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="N° Devis"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="N° Appareil"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field
                  outlined
                  hide-details
                  label="N° Dossier"
                  v-model="project.file_number"
                ></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="Nom" v-model="patient.lastname"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="Prénom" v-model="patient.firstname"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="Date de naissance" v-model="patient.dob"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="N° de Sécu" v-model="patient.nir"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5>
                <v-text-field outlined hide-details label="Clé" v-model="patient.nir_key"></v-text-field>
              </v-flex>
              <v-flex sm4 mb-5></v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm3>
            <v-radio-group
              v-validate="'required'"
              :error-messages="errors.collect('projectMethod')"
              data-vv-name="projectMethod"
              hide-details
              v-model="project.project_method"
            >
              <v-radio label="Essayage" value="FITTING"></v-radio>
              <v-radio label="Préfinition" value="PREFINISHING"></v-radio>
              <v-radio label="Livraison directe" value="DIRECT_DELIVERY"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex>
            <v-radio-group
              v-validate="'required'"
              :error-messages="errors.collect('renew')"
              data-vv-name="renew"
              row
              hide-details
              v-model="project.renew"
            >
              <v-radio label="Première installation" value="FIRST_INSTALLATION"></v-radio>
              <v-radio label="Renouvellement" value="RENEW"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-tabs v-model="tab">
          <v-layout justify-space-around>
            <v-tab>Coordonnées</v-tab>
            <v-tab>Programmation</v-tab>
          </v-layout>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-layout justify-space-between wrap>
                <v-flex sm5 mb-5>
                  <v-text-field hide-details outlined label="Adresse" v-model="patient.address"></v-text-field>
                </v-flex>
                <v-flex sm5 mb-5>
                  <v-text-field hide-details outlined label="Ville" v-model="patient.city"></v-text-field>
                </v-flex>
                <v-flex sm2>
                  <v-text-field hide-details outlined label="CP" v-model="patient.zipcode"></v-text-field>
                </v-flex>
                <v-flex sm5 mb-5>
                  <v-text-field hide-details outlined label="Téléphone" v-model="patient.phone"></v-text-field>
                </v-flex>
                <v-flex sm5 mb-5>
                  <v-text-field hide-details outlined label="Mobile" v-model="patient.cellular"></v-text-field>
                </v-flex>
                <v-flex sm2>
                  <v-btn disabled>
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout justify-space-between wrap>
                <v-flex sm4 mb-5>
                  <!-- Date Picker Essayge 1 -->
                  <v-menu
                    ref="datePicker1"
                    :disabled="isDirectDelivery"
                    v-model="datePicker1"
                    :close-on-content-click="false"
                    :return-value.sync="project.fitting1_at"
                    transition="scale-transition"
                    offset-y
                    full-width
                    color="#880e4f"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="project.fitting1_at"
                        :disabled="isDirectDelivery"
                        label="Date Essayage 1"
                        readonly
                        hide-details
                        outlined
                        v-on="on"
                        clearable
                        class="mb-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="project.fitting1_at" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="#880e4f" @click="datePicker1 = false">Annuler</v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="$refs.datePicker1.save(project.fitting1_at)"
                      >Ok</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- End DatePicker -->
                </v-flex>
                <v-flex sm4 mb-5>
                  <!-- Date Picker Essayge 2 -->
                  <v-menu
                    ref="datePicker2"
                    :disabled="isDirectDelivery || isPrefinishing || !project.fitting1_at"
                    v-model="datePicker2"
                    :close-on-content-click="false"
                    :return-value.sync="project.fitting2_at"
                    transition="scale-transition"
                    offset-y
                    full-width
                    color="#880e4f"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="project.fitting2_at"
                        :disabled="isDirectDelivery || isPrefinishing || !project.fitting1_at"
                        label="Date Essayage 2"
                        readonly
                        clearable
                        hide-details
                        outlined
                        v-on="on"
                        class="mb-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="project.fitting2_at" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="#880e4f" @click="datePicker2 = false">Annuler</v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="$refs.datePicker2.save(project.fitting2_at)"
                      >Ok</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- End DatePicker -->
                </v-flex>
                <v-flex sm4>
                  <!-- Date Picker Essayge 3 -->
                  <v-menu
                    ref="datePicker3"
                    :disabled="isDirectDelivery || isPrefinishing || !project.fitting_at2"
                    v-model="datePicker3"
                    :close-on-content-click="false"
                    :return-value.sync="project.fitting3_at"
                    transition="scale-transition"
                    offset-y
                    full-width
                    color="#880e4f"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="project.fitting3_at"
                        :disabled="isDirectDelivery || isPrefinishing || !project.fitting_at2"
                        label="Date Essayage 3"
                        readonly
                        clearable
                        hide-details
                        outlined
                        v-on="on"
                        class="mb-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="project.fitting3_at" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="#880e4f" @click="datePicker3 = false">Annuler</v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="$refs.datePicker3.save(project.fitting3_at)"
                      >Ok</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- End DatePicker -->
                </v-flex>
                <v-flex sm4 mb-5>
                  <!-- Date Picker planned delivery -->
                  <v-menu
                    ref="datePicker4"
                    v-model="datePicker4"
                    :close-on-content-click="false"
                    :return-value.sync="project.planned_delivery_at"
                    transition="scale-transition"
                    offset-y
                    full-width
                    color="#880e4f"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="project.planned_delivery_at"
                        label="Livraison Prévue"
                        readonly
                        clearable
                        hide-details
                        outlined
                        v-on="on"
                        class="mb-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="project.planned_delivery_at" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="#880e4f" @click="datePicker4 = false">Annuler</v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="$refs.datePicker4.save(project.planned_delivery_at)"
                      >Ok</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- End DatePicker -->
                </v-flex>
                <v-flex sm4 mb-5>
                  <!-- Date Picker real delivery -->
                  <v-menu
                    ref="datePicker5"
                    v-model="datePicker5"
                    :close-on-content-click="false"
                    :return-value.sync="project.real_delivery_at"
                    transition="scale-transition"
                    offset-y
                    full-width
                    color="#880e4f"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="project.real_delivery_at"
                        label="Livraison Réelle"
                        readonly
                        clearable
                        hide-details
                        outlined
                        v-on="on"
                        class="mb-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="project.real_delivery_at" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="#880e4f" @click="datePicker5 = false">Annuler</v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="$refs.datePicker5.save(project.real_delivery_at)"
                      >Ok</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- End DatePicker -->
                </v-flex>
                <v-flex sm4 mb-5></v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <v-layout mt-5 justify-space-between>
          <v-flex sm7>
            <v-select
              v-model="project.agency_id"
              :items="agenciesItems"
              v-validate="'required'"
              :error-messages="errors.collect('agency')"
              data-vv-name="agency"
              placeholder="Sélectionner un centre"
              clearable
              filled
            ></v-select>
          </v-flex>
          <v-flex sm5>
            <v-layout justify-space-between>
              <v-flex sm4>
                <v-btn block disabled>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm4>
                <v-btn block disabled>
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm4>
                <v-btn block disabled>
                  <v-icon>mdi-eraser</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout mt-5 justify-space-between>
          <v-flex sm7>
            <v-select
              filled
              :items="models"
              v-model="project.product_model"
              v-validate="'required'"
              :error-messages="errors.collect('product')"
              data-vv-name="product"
              placeholder="Sélectionner un modèle de fiche"
            ></v-select>
          </v-flex>
          <v-flex sm5>
            <v-btn
              block
              @click="onProductClick"
              :disabled="disableProductBtn"
            >Ouvrir fiche applicateur</v-btn>
          </v-flex>
        </v-layout>
        <v-layout mt-5 justify-space-between>
          <v-flex sm6>
            <v-select
              filled
              :items="usersItems"
              v-model="project.applicator_id"
              v-validate="'required'"
              :error-messages="errors.collect('applicator')"
              data-vv-name="applicator"
              placeholder="Sélectionner un  applicateur"
              clearable
            ></v-select>
          </v-flex>
          <v-flex sm6>
            <v-select
              filled
              :items="usersItems"
              v-model="project.applicator_supp_id"
              placeholder="Sélectionner un suppléant"
              clearable
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout justify-space-between mb-4>
          <v-flex sm6>
            <v-textarea
              filled
              name="Ajouter un commentaires :"
              label="Ajouter un commentaires :"
              value
              rows="3"
              hide-details
            ></v-textarea>
          </v-flex>
          <v-flex sm6>
            <v-btn block @click="onTransferClick" :disabled="disableProductBtn">
              <v-icon class="mr-2">mdi-send</v-icon>Transférer « appareil livré »
            </v-btn>
            <v-layout justify-space-between class="mt-3">
              <v-flex sm6>
                <v-btn block disabled>
                  <v-icon class="mr-2">mdi-image-size-select-actual</v-icon>Médias
                </v-btn>
              </v-flex>
              <v-flex sm6>
                <v-btn block disabled>
                  <v-icon class="mr-2">mdi-content-duplicate</v-icon>Dupliquer
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-space-between>
          <v-flex sm6>
            <v-switch label="Non gérée chef atelier" hide-details disabled></v-switch>
            <v-switch
              v-model="project.transferable"
              label="Fiche transferable"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-flex>
          <v-flex sm3>
            <v-checkbox disabled hide-details label="Appareil livré" class="mr-4 mt-2"></v-checkbox>
            <v-checkbox
              disabled
              hide-details
              label="Finition lancement fabrication"
              class="mr-4 mt-2"
            ></v-checkbox>
          </v-flex>
          <v-flex sm3>
            <v-checkbox disabled hide-details label="Couture OK" class="mr-4 mt-2"></v-checkbox>
            <v-checkbox disabled hide-details label="Essai lancement fabrication" class="mr-4 mt-2"></v-checkbox>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div class="save-container">
      <v-btn class="cancel" @click="onCancel">
        <v-icon>mdi-close</v-icon>Annuler
      </v-btn>
      <v-btn class="save" @click="onSubmit">
        <v-icon>mdi-content-save</v-icon>Enregistrer
      </v-btn>
    </div>

    <v-snackbar color="error" v-model="showErrors" :timeout="2000" top multi-line>
      Verifier le formulaire
      <v-btn text @click="showErrors = false">Fermer</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProjectForm",
  props: {
    project: {
      type: Object,
      required: true
    },
    patient: {
      type: Object,
      required: true
    },
    disableProductBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tab: null,
      localProject: null,
      localPatient: null,
      localAgencies: null,
      localUsers: null,

      showErrors: false,

      datePicker1: false,
      datePicker2: false,
      datePicker3: false,
      datePicker4: false,
      datePicker5: false
    };
  },
  computed: {
    usersItems() {
      if (this.localUsers) {
        return this.localUsers.map(user => {
          return {
            text: `${user.lastname} ${user.firstname}`,
            value: user.id
          };
        });
      }
      return null;
    },

    agenciesItems() {
      if (this.localAgencies) {
        return this.localAgencies.map(agency => {
          return {
            text: agency.name,
            value: agency.id
          };
        });
      }
      return null;
    },

    models() {
      return [
        {
          text: "Minerve",
          value: "NECK_BRACE"
        },
        {
          text: "Siège moulé",
          value: "MOLDED_SEAT"
        },
        {
          text: "Otn",
          value: "OTN"
        },
        {
          text: "Verticalisateur",
          value: "LIFT"
        },
        {
          text: "Retouche/Réparation",
          value: "RETOUCHING_REPAIR"
        },
        {
          text: "Selle",
          value: "SEAT"
        },
        {
          text: "Selle de positionnement",
          value: "POSITIONING_SEAT"
        },
        {
          text: "Othèse M sup",
          value: "UPPER_LIMB_ORTHOSIS"
        },
        {
          text: "Othèse M inf",
          value: "LOWER_LIMB_ORTHOSIS"
        },
        {
          text: "Corset",
          value: "CORSET"
        }
      ];
    },

    isFitting() {
      return this.project.project_method === "FITTING";
    },

    isPrefinishing() {
      return this.project.project_method === "PREFINISHING";
    },

    isDirectDelivery() {
      return this.project.project_method === "DIRECT_DELIVERY";
    }
  },
  methods: {
    ...mapActions({
      getLocalUsers: "users/getLocalUsers",
      getLocalAgencies: "agencies/getLocalAgencies"
    }),

    // Emit on-submit on submit
    async onSubmit() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        this.showErrors = true;
        return;
      }
      this.$emit("on-submit");
    },

    // Emit on-cancel on cancel
    onCancel() {
      this.$emit("on-cancel");
    },

    // Emit on-product-click
    onProductClick() {
      this.$emit("on-product-click");
    },

    // Emit on-transfer-click
    onTransferClick() {
      this.$emit("on-transfer-click");
    }
  },
  async mounted() {
    this.localProject = this.project;
    this.localPatient = this.patient;

    this.localAgencies = await this.getLocalAgencies();
    this.localUsers = await this.getLocalUsers();
  }
};
</script>

<style lang="scss">
.project-form {
  margin: -12px;
  .v-input--selection-controls {
    margin-top: 0;
    padding: 0;
  }
  .v-tabs {
    .v-item-group {
      .v-tab {
        color: #006064;
        font-weight: 400;
        &.v-tab--active {
          color: #880e4f !important;
          &::before {
            color: #880e4f !important;
          }
        }
      }
      .v-tabs-slider {
        background-color: #880e4f !important;
      }
    }
  }
  .v-window {
    border-top: 1px solid rgba(#d4d4d5, 0.5);
    border-bottom: 1px solid rgba(#d4d4d5, 0.5);
    padding-top: 15px;
  }
  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px 45px;
    .v-btn {
      background-color: #006064 !important;
      color: white !important;
    }
  }
}
</style>
